<template>
  <div class="customer-slider-container">
    <h2>{{ customerTitle }}</h2>

    <Swiper :slidesPerView="5" :spaceBetween="50" :loop="true" :autoplay="{
      delay: 2500,
      disableOnInteraction: false,
    }" :modules="modules"
    :breakpoints="{
    300: { // screen width >= 300px
      slidesPerView: 1,
    },
    650: { // screen width >= 450px
      slidesPerView: 3,
    },
    1000: { // screen width >= 1000px
      slidesPerView: 5,
    }
  }"
    class="mySwiper">

      <SwiperSlide v-for="(customer,index) in getCustomers" :key="index" class="box">
        <a :href="customer.link" target="_blank" rel="noopener noreferrer">
          <!-- <img @contextmenu.prevent :src="require(`../../assets/customer/${customer.img}`) "> -->
           <img @contextmenu.prevent :src="imageSrc(customer.path)">
        </a>
      </SwiperSlide>
    </Swiper>
  </div>
</template>
<script>
import { Swiper, SwiperSlide } from 'swiper/vue'
import 'swiper/css'
import { Autoplay } from 'swiper/modules'

// Import Swiper styles
// import 'swiper/css'

// import 'swiper/css/pagination'
// import { Pagination } from 'swiper/modules'
export default {
  components: {
    Swiper,
    SwiperSlide
  },
  setup () {
    return {
      modules: [Autoplay]
    }
  },
  data () {
    return {
      cacheBuster: Date.now()
    }
  },
  computed: {
    customerTitle () {
      if (this.$store.state.lang === 'vn') return 'khách hàng'
      else return 'Customers'
    },
    getCustomers () {
      return this.$store.getters['media/getCustomers']
    }
  },
  methods: {
    imageSrc (src) {
      return `${src}?t=${this.cacheBuster}`
    }
  }
}
</script>
<style scoped>
  .customer-slider-container {
    /* border: 1px solid black; */
    width: 100%;
  }

  .customer-slider-container h2 {
    font-weight: 700;
    color: #006884;
    text-transform: uppercase;
    margin: 50px 0px;
    text-align: center;
    font-size: 28px;
  }

  .swiper {
    width: 100%;
  }

  /* .swiper-slide img {
    display: block;
    object-fit: cover;
    max-width: 180px;
    max-height: 70px;
  } */

  .box {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100px;
    margin-bottom: 50px;
    padding: 2px;
  }

  .box a {
    width: 100%;
    height: 100%;
    padding: 5px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    background-color: white;
  }

  .box img {
    max-width: 100%;
    max-height: 100%;
  }

  @media (max-width: 720px) {

    .customer-slider-container h2 {
      font-size: 22px;
    }
  }
</style>
